module.exports = __webpack_public_path__ + "static/customer-dispute-management-039e4b68f04a35c1fb9b5dd284a9da31.png";